import {Component} from '@angular/core';
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule} from "@angular/forms";
import {Router} from "@angular/router";
import {TourService} from "../classes/tour.service";
import {CommonModule} from "@angular/common";
import {MatDialogRef} from "@angular/material/dialog";
import {Analytics, logEvent} from "@angular/fire/analytics";
import {LanguageService} from "../classes/language.service";

@Component({
  selector: 'app-dialpad-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatButtonModule,
    FormsModule
  ],
  templateUrl: './dialpad-dialog.component.html',
  styleUrl: './dialpad-dialog.component.scss'
})
export class DialpadDialogComponent {
  dialNumber: number;
  error: string = null;


  constructor(
    private router: Router,
    private tourService: TourService,
    private matDialogRef: MatDialogRef<DialpadDialogComponent>,
    private analytics: Analytics,
    private languageService: LanguageService,
  ) {
  }

  async goToNumber() {
    console.log('Go to number', this.dialNumber);
    if (!this.dialNumber || this.dialNumber <= 0) return;

    const tour = await this.tourService.getTourByStepNumber(this.dialNumber).catch(() => {
      this.error = $localize`Tour not found`;
      console.error('Tour not found');
      return null;
    });

    console.log('Tour', tour);
    console.log('error', this.error);

    if (!tour) {
      logEvent(this.analytics, 'tour_dialpad_error', {
        "dialpad_number": this.dialNumber,
        "error": "tour_not_found",
        "language": this.languageService.currentLang$.value,
        "current_step": this.tourService.activeTour$.value?.step ?? "null"
      })
      return;
    }

    logEvent(this.analytics, 'tour_dialpad_success', {
      "tour": "main_tour",
      "step": this.dialNumber,
      "step_id": tour.id,
      "language": this.languageService.currentLang$.value,
      "current_step": this.tourService.activeTour$.value?.step ?? "null"
    });

    this.matDialogRef.close();

    this.router.navigate(['/tours/view', tour.id]);
  }
}
